import { useRouter } from 'next/router'

import CardLists from '@/components/CardLists/CardLists'
import Container from '@/components/Container/Container'
import DefaultHead from '@/components/DefaultHead/DefaultHead'
import Header from '@/components/Header/Header'
import Panels from '@/components/Panels/Panels'
import SubMenu from '@/components/SubMenu/SubMenu'
import { COLORS, CommanderPageType, TIMESPANS } from '@/types/page'
import { serverSidePropsFor } from '@/utils/helpers'
import useDirectories from '@/utils/useDirectories'

const SUBMENU_ITEMS = [
  { name: 'Past 2 Years', url: '/commanders' },
  { name: 'Past Month', url: '/commanders/month' },
  { name: 'Past Week', url: '/commanders/week' },
]

const colorMenuItems = (cid: string) => [
  { name: 'Commanders', url: `/commanders/${cid}` },
  { name: 'Staples', url: `/commanders/${cid}/staples` },
  { name: 'Mana Staples', url: `/commanders/${cid}/mana-staples` },
]

type Props = {
  data: CommanderPageType
}

const CommanderPage = ({ data }: Props) => {
  const { subpage } = useDirectories()
  const router = useRouter()
  const isColorPage = COLORS.includes(router.query.slug as string)
  const isTimespanPage = TIMESPANS.includes(router.query.slug as string)

  return (
    <>
      <DefaultHead data={data} />
      {isColorPage || isTimespanPage ? (
        <>
          <Header>{data.header}</Header>
          <SubMenu items={isColorPage ? colorMenuItems(subpage) : SUBMENU_ITEMS} />
        </>
      ) : (
        <Container>
          <Header>{data.header}</Header>
          <Panels data={data} />
        </Container>
      )}
      <CardLists card={data.container.json_dict.card} initCardLists={data.container.json_dict.cardlists} />
    </>
  )
}

export const getServerSideProps = serverSidePropsFor(`https://json.edhrec.com/pages/commanders/year.json`)

export default CommanderPage
